import React from "react";
import { Upload, File, X } from "lucide-react";

const FileUpload = ({
  label,
  name,
  files = [], // Array of files now
  onUpload,
  onDelete,
  required = false,
  accept = "*/*",
  description,
}) => {
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    console.log("[FileUpload] selectedFiles:", selectedFiles);
    if (selectedFiles.length > 0) {
      console.log("[FileUpload] calling onUpload with:", name, selectedFiles);
      onUpload(name, selectedFiles);
    }
  };

  const handleRemoveFile = (key) => {
    if (name && key) {
      onDelete(name, key);
    } else {
      console.error("Missing values for deletion");
    }
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-light text-muted-foreground mb-1">
        {label}
        {required && <span className="text-brand ml-1">*</span>}
      </label>

      {description && (
        <p className="text-sm text-muted-foreground font-light mb-2">{description}</p>
      )}

      <label className="border-2 border-dashed border-border rounded-lg p-6 text-center hover:border-brand hover:border-opacity-50 transition-colors duration-200 bg-card cursor-pointer block mb-4">
        <Upload className="mx-auto h-12 w-12 text-muted-foreground" />
        <div className="mt-4">
          <span className="mt-2 block text-sm font-light text-muted-foreground">
            Click to upload {files.length > 0 ? "more" : ""} files
          </span>
        </div>
        <input
          type="file"
          className="hidden"
          accept={accept}
          multiple
          onChange={handleFileChange}
          required={required && files.length === 0}
        />
      </label>

      {files.length > 0 && (
        <div className="space-y-2">
          {files.map((file, index) => (
            <div
              key={file.key || index}
              className="flex items-center justify-between p-3 bg-muted/30 rounded-lg border border-brand/30"
            >
              <div className="flex items-center overflow-hidden">
                <File className="h-5 w-5 text-brand mr-2 shrink-0" />
                <span className="text-sm text-foreground font-light truncate max-w-xs">
                  {file.fileName}
                </span>
                <span className="text-xs text-muted-foreground ml-2 shrink-0">
                  ({(file.size / 1024).toFixed(1)} KB)
                </span>
              </div>
              <button
                type="button"
                onClick={() => handleRemoveFile(file.key)}
                className="text-red-400 hover:text-red-300 transition-colors duration-200"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
